import * as Sentry from '@sentry/nextjs';

export type LayoutDiagnosticsPhase =
  | 'layout-init-start'
  | 'layout-init-complete'
  | 'layout-init-error'
  | 'seamless-registration-opened'
  | 'seamless-registration-tracking-skipped'
  | 'seamless-registration-tracking-fired';

export interface LayoutDiagnosticsEvent {
  phase: LayoutDiagnosticsPhase;
  message: string;
  context?: Record<string, string | number | boolean | null | undefined>;
}

const breadcrumbPhases = new Set<LayoutDiagnosticsEvent['phase']>([
  'layout-init-start',
  'layout-init-complete',
  'seamless-registration-opened',
  'seamless-registration-tracking-fired',
]);

export const reportLayoutDiagnostics = (
  event: LayoutDiagnosticsEvent
): void => {
  if (breadcrumbPhases.has(event.phase)) {
    Sentry.addBreadcrumb({
      category: 'layout',
      level: 'info',
      message: event.message,
      data: {
        phase: event.phase,
        ...event.context,
      },
    });
    return;
  }

  const level = event.phase === 'layout-init-error' ? 'error' : 'warning';

  Sentry.captureMessage(event.message, {
    level,
    tags: {
      feature: 'layout',
      phase: event.phase,
    },
    extra: event.context,
  });
};
